// export const BaseUrl = "https://127.0.0.1:8000";
// export const BaseUrl = "https://227687.fornex.cloud"
export const BaseUrl = "https://booking-bot.tech"
// export const user =  'deadulya';
export const tg_user =  window.Telegram.WebApp.initDataUnsafe.user ? window.Telegram.WebApp.initDataUnsafe.user.username : null;
